<style>
.van-popup.van-toast {
  background: var(--van-toast-background) !important;
  box-sizing: content-box !important;
  transition: all var(--van-duration-fast) !important;
  width: 200px !important;
  max-width: 800px !important;
}
input::placeholder{
  font-size: 36px !important;
  font-family: 'PingFang SC' !important;
  opacity: 0.8 !important;
}

.invite-wrap {
  background: var(--theme-bg-muted);
}

.invite-input {
  color: var(--theme-text-primary);
}

.invite-confirm-btn {
  color: #FFFFFF;
  background: linear-gradient(180deg, #00C1FF 0%, #0054D3 100%);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}
</style>
<template>
  <Nav :theme="theme" @connectWallet="init" />
  <NetworkErr @confirm="init" ref="networkErrRef" />
  <div id="main">
    <router-view></router-view>
  </div>
  <van-popup v-model:show="show" position="bottom" round closeable @close="() => { }" safe-area-inset-bottom>
    <div class="pt-[36px] pb-[40px] px-20px">
      <div class="mb-40 text-[36px] font-pingfang font-700">邀请码</div>
      <div class="invite-wrap px-28 py-40 rounded-[16px] mb-40">
        <input type="text" v-model="invitationCode" class="invite-input outline-none border-none bg-[#fff]/0 font-pingfang text-[36px]"
          placeholder="请输入邀请码" />
      </div>
      <div
      @click="handleConfirmCode"
      :class="invitationCode ? 'opacity-100' : 'opacity-50'"
        class="invite-confirm-btn van-haptics-feedback disabled:opacity-50 py-32 text-[32px] font-roboto rounded-[4px] flex items-center justify-center">
        确 定</div>
    </div>
  </van-popup>
</template>

<script setup>
import Nav from '@/components/header.vue'
import NetworkErr from '@/components/networkErr.vue'
import { watch, ref,onMounted } from 'vue'
import { useRoute } from 'vue-router'
import useWeb3 from '@/utils/useWeb3'
import { showToast } from 'vant'
import { useIndexStore } from '@/store'
import api from '@/apis'
import config from '@/config'
const show = ref(false)
const store = useIndexStore()
const route = useRoute()
const theme = ref('') // dark light
let invitationCode = ref('')
//监听地址变化
useWeb3.onAccountChange((address) => {
  store.setToken('')
  setTimeout(() => {
    window.location.reload()
  }, 800)
})

let networkErrRef = ref(null)

let handleConfirmCode = async   () => {
  if(!invitationCode.value){
    return
  }
  show.value = false
  login()
}

const init = async () => {  
  invitationCode.value = route.query?.code || ''
  if(config.env == 'dev' && invitationCode.value == ''){
    invitationCode.value = config.debugCode
  }
  try {
    await useWeb3.ensureReady()
    // if (window.ethereum.chainId != config.network.chainId) {
    //   networkErrRef.value.open()
    //   return
    // }
    let address = useWeb3.signer?.address
    const isRegister = await api.home.isRegister({ address })
    if (!isRegister?.isRegister){
      invitationCode.value = route.query?.code || ''
      show.value = true
      return
    }
    login()
  } catch (error) {
    console.log('[  ] >', error)
  }
}

let login = async () => {
  await useWeb3.ensureReady()
  let address = useWeb3.signer?.address
  const { message } = await api.home.loginMessage()
  const signature = await useWeb3.signMessage(`${message}`)
  const res = await api.home.login({ address: address, message, sign_message: signature, code: invitationCode.value })
  store.setAddress(address)
  store.setToken(res.token)
  // 登录成功后获取用户信息
  await store.fetchUserInfo()
}
useWeb3.onChainChange((chainId) => {
  console.log(chainId)
  console.log(window.ethereum.chainId, config.network.chainId)
  if (window.ethereum.chainId != config.network.chainId) {
    networkErrRef.value.open()
    return
  }
})
onMounted(() => {
  if(config.isVerifyToken){
    init()
  }
})
//监听路由变化
watch(() => route.path, (val) => {
  theme.value = route.meta.headerTheme || 'light'
})


</script>
